module.exports = __webpack_public_path__ + "media/src/images/usr_txt_univ-c3c1107111d92c08f2da7975e8a41d89.png";